/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface BCMBookingIdRemarkRuleListConfiguration
 */
export interface BCMBookingIdRemarkRuleListConfiguration {
    /**
     * 
     * @type {Array<BrandAndMarketListItem>}
     * @memberof BCMBookingIdRemarkRuleListConfiguration
     */
    readonly brandsAndMarkets?: Array<BrandAndMarketListItem> | null;
}

export function BCMBookingIdRemarkRuleListConfigurationFromJSON(json: any): BCMBookingIdRemarkRuleListConfiguration {
    return BCMBookingIdRemarkRuleListConfigurationFromJSONTyped(json, false);
}

export function BCMBookingIdRemarkRuleListConfigurationFromJSONTyped(json: any, ignoreDiscriminator: boolean): BCMBookingIdRemarkRuleListConfiguration {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'brandsAndMarkets': !exists(json, 'brandsAndMarkets') ? undefined : (json['brandsAndMarkets'] === null ? null : (json['brandsAndMarkets'] as Array<any>).map(BrandAndMarketListItemFromJSON)),
    };
}

export function BCMBookingIdRemarkRuleListConfigurationToJSON(value?: BCMBookingIdRemarkRuleListConfiguration | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
    };
}


